import React, { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import "../css/ForgotPasswordForm.css";
import OtpScreen from "./OtpScreen";
import { useUsersdata } from "../../../_helper/actions/app/items";
import {
  useChangepassword,
  useVerifyOTP,
} from "../../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
// import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
// import forgotPassSchema from "../../../schemas/authentication/forgot-pass-schema";
// import { useMediaQuery } from "react-responsive";
import { isuserside } from "../../user/User-Detail/user-details-tab/UserDetailsAtom";
import { useLoginUser } from "../../../_helper/actions/mutation/login";
import { useCurrentRole } from "../../../_helper/constant/Permission";
import { setAuthToken } from "../../../_helper/constant/auth";
// import { RemoteLogIn } from "remote/Auth";
import PasswordInput from "./PasswordInput";
import { useCreateOTP } from "../../../_helper/actions/mutation/register";

const ForgotPasswordForm = ({
  setIsSignup,
  setIsForgotPassword,
  steps,
  setSteps,
}) => {
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [mobileNo, setMobileNo] = useState("");
  const [err, setErr] = useState("");
  const [isSentOtp, setSentOtp] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [Password, setPassword] = useState({
    password: "",
    confirmpassword: "",
  });
  // const [userId, setUserid] = useState("");
  const mutation = useChangepassword("change");
  const navigate = useNavigate();
  // const [clinic] = useAtom(clinicAtom);
  const loginmutation = useLoginUser("login");
  const { role_name, user_personal_details_id } = useCurrentRole();
  const [, setuserside] = useAtom(isuserside);
  const [selectedOption, setSelectedOption] = useState("cufront"); // Default to clinic

  const [otp, setOtp] = useState(["", "", "", ""]);

  // Determine the default selection based on the subdomain
  useEffect(() => {
    const hostname = window.location.hostname; // Get current domain
    const subdomain = hostname.split(".")[0]; // Extract subdomain

    if (
      subdomain.includes("pharmacy") ||
      ["venus-pharmacy", "moon-pharmacy"].includes(subdomain)
    ) {
      setSelectedOption("pharmacy");
    } else if (
      subdomain.includes("doctor") ||
      ["venus", "moon"].includes(subdomain)
    ) {
      setSelectedOption("cufront");
    }
  }, []);

  const onSubmit = (data) => {
    loginmutation.mutate(data, {
      onSuccess: (data) => {
        setAuthToken(data.access_token);
        // RemoteLogIn(data.access_token);
        localStorage.setItem("access_token", data.access_token);
        // localStorage.setItem("refresh_token", data.refresh_token);
      },
    });
  };

  useEffect(() => {
    if (Boolean(localStorage.getItem("access_token"))) {
      if (role_name === "Patient") {
        setuserside(true);
        navigate(`/user/user_details/${user_personal_details_id}`);
      } else if (
        role_name === "Administrator" ||
        role_name === "Doctor" ||
        role_name === "Receptionist"
      ) {
        navigate("/appointment");
      }
    }
  }, [role_name]);

  const changepass = (e) => {
    e.preventDefault();

    const { password, confirmpassword } = Password;
    if (password !== confirmpassword) {
      setErr("Password and confirm password must be same");
      return;
    }

    const payload = {
      action: "reset_password",
      domain: `${selectedOption}.com`,
      mobile: mobileNo,
      password: password,
      password_confirm: confirmpassword,
      otp: otp.join(""),
    };

    mutation.mutate(payload, {
      onSuccess: () => {
        onSubmit({
          email: `${mobileNo}@${selectedOption}.com`,
          password: password,
        });
        setMobileNo("");
        setPassword({ password: "", confirmpassword: "" });
      },
      onError: (err) => {
        setErr(err?.response?.data?.msg);
      },
    });
  };

  const otpQuery = `change/?mobile=${mobileNo}&action=send&domain=${selectedOption}.com`;
  const otpmutation = useCreateOTP(otpQuery);
  const OTPVerifymutation = useVerifyOTP("change");

  // const otpSubmitHandler = (otp) => {
  //   OTPVerifymutation.mutate(
  //     { otp, mobile: `${mobileNo}` },
  //     {
  //       onSuccess: (data) => {
  //         if (data?.data?.type === "success") {
  //           setIsOTPVerified(true);
  //         } else {
  //           setErr(data?.data?.message);
  //         }
  //       },
  //       onError: (err) => {
  //         setErr("Something went wrong");
  //       },
  //     }
  //   );
  // };

  const nextStepToPassword = () => {
    setSteps((prev) => prev + 1);
  };

  const sendOtpHandler = (type) => {
    setSteps((prev) => prev + 1);

    otpmutation.mutate(
      {
        mobile: mobileNo,
        category: type,
      },
      {
        onSuccess: () => {
          setSentOtp(true);
          setResendDisabled(true);
        },
        onError: (err) => {
          setErr(err?.response?.data?.msg);
        },
      }
    );
  };

  useEffect(() => {
    let timer;
    if (err?.length > 0) {
      timer = setTimeout(() => {
        setErr("");
      }, 10000);
    }
    return () => clearTimeout(timer);
  }, [err]);

  const getIsDisabled = () => {
    if (mobileNo?.length === 10) {
      return false;
    } else {
      return true;
    }
  };

  const onChangeHandler = (e) => {
    setMobileNo(e.target.value);
  };

  const onPasswordChange = (e, fieldName) => {
    setPassword((prev) => ({ ...prev, [fieldName]: e.target.value }));
  };

  // const signupLinkHandler = () => {
  //   setIsForgotPassword(false);
  //   setIsSignup(true);
  // };

  return (
    <>
      <div className="auth-header">Forgot password</div>
      <form
        className="forgot-pass-form"
        style={{
          marginBlockStart: isSentOtp && !isOTPVerified ? "-20px" : "115px",
        }}
        onSubmit={changepass}
      >
        {(!isSentOtp || steps == 2) && (
          <>
            <input
              placeholder="Enter mobile number"
              value={mobileNo}
              // type="number"
              onChange={onChangeHandler}
              type="text"
              maxlength="10"
              pattern="\d{10}"
            />

            <Button
              fluid
              color="black"
              disabled={getIsDisabled()}
              type="button"
              loading={otpmutation.isLoading}
              onClick={() => sendOtpHandler("send")}
            >
              Get OTP
            </Button>
          </>
        )}

        {steps == 4 && (
          <>
            <PasswordInput
              placeholder={"Enter new password"}
              value={Password.password}
              onChange={(e) => onPasswordChange(e, "password")}
            />
            <PasswordInput
              placeholder={"Confirm password"}
              value={Password.confirmpassword}
              onChange={(e) => onPasswordChange(e, "confirmpassword")}
            />
            <Button
              color="black"
              fluid
              type="submit"
              loading={mutation.isLoading}
            >
              Sign in
            </Button>
          </>
        )}
      </form>

      {isSentOtp && steps == 3 && !isOTPVerified && (
        <OtpScreen
          mobileNo={mobileNo}
          btnText={"Submit"}
          resendDisabled={resendDisabled}
          setResendDisabled={setResendDisabled}
          sendOtpHandler={sendOtpHandler}
          otpSubmitHandler={nextStepToPassword}
          loading={OTPVerifymutation.isLoading}
          otp={otp}
          setOtp={setOtp}
        />
      )}

      {/* 
{true && !isOTPVerified && (
        <OtpScreen
          mobileNo={mobileNo}
          btnText={"Submit"}
          resendDisabled={resendDisabled}
          setResendDisabled={setResendDisabled}
          sendOtpHandler={sendOtpHandler}
          otpSubmitHandler={otpSubmitHandler}
          loading={OTPVerifymutation.isLoading}
        />
      )}
       */}
      {err?.length > 0 && (
        <div className="auth-errors">
          {err}{" "}
          {/* {userId?.length === 0 && (
            <span onClick={signupLinkHandler}>Click here to sign up</span>
          )} */}
        </div>
      )}
    </>
  );
};

export default ForgotPasswordForm;
